import { render, staticRenderFns } from "./ms-create-check.vue?vue&type=template&id=4b8fc582&scoped=true"
import script from "./ms-create-check.vue?vue&type=script&lang=js"
export * from "./ms-create-check.vue?vue&type=script&lang=js"
import style0 from "./ms-create-check.vue?vue&type=style&index=0&id=4b8fc582&prod&lang=scss"
import style1 from "./ms-create-check.vue?vue&type=style&index=1&id=4b8fc582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8fc582",
  null
  
)

export default component.exports